export default __webpack_public_path__ + "static/media/kindly-privacy.7a278a64.svg";